/* eslint-disable @typescript-eslint/no-explicit-any */
import {DATE_FORMAT} from 'commons/dates';
import {intervalToDuration, parse} from 'date-fns';
import useUser from 'hooks/useUser';
import {labelFromType} from 'models/leaveRequestType';
import {FC, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

export interface LeavesModel {
  availableDays?: number;
  vacationDays?: number;
  additionalLeaveDays?: number;
  totalAdditionalLeaveDays?: number;
  usedAdditionalLeaves?: number;
  accumulatedDays?: number;
  daysToExpire?: string[];
  usedDays?: number;
  yearsOfService?: number;
}

export const withLeavesViewModel =
  () => (Component: FC<any>) => (props: any) => {
    const {userDetails, fetchUser} = useUser();
    const {t} = useTranslation();

    useEffect(() => {
      fetchUser();
      // fetchUser se recrea en cada render (no está en useCallback en useUser).
      // Este efecto es intencional solo al montar — equivalente a componentDidMount.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const balance = useMemo<LeavesModel | null>(() => {
      if (!userDetails?.data) return null;
      const rawBalance = userDetails.data.leaveBalance;
      const yearsOfService = intervalToDuration({
        start: parse(
          userDetails.data.hiringDate || '',
          DATE_FORMAT,
          new Date()
        ),
        end: new Date(),
      });
      return {
        availableDays: rawBalance?.availableDays,
        vacationDays: rawBalance?.vacationDays,
        additionalLeaveDays: rawBalance?.additionalLeaveDays,
        totalAdditionalLeaveDays: rawBalance?.totalAdditionalLeaveDays,
        usedAdditionalLeaves: rawBalance?.usedAdditionalLeaves,
        accumulatedDays: rawBalance?.accumulatedDays,
        usedDays: rawBalance?.usedDays,
        yearsOfService: yearsOfService.years,
        daysToExpire: rawBalance?.daysToExpire?.map(day =>
          t('leaves.notice_expire_message', {
            type: t(labelFromType(day.type)),
            days: Math.floor(day.days * 100) / 100,
            date: day.date,
          })
        ),
      };
    }, [userDetails, t]);

    return <Component {...{balance}} {...props} />;
  };
export default withLeavesViewModel;
